import {
  Alert
} from 'reactstrap'

import { FormattedMessage } from 'react-intl'
import messages from 'i18n/messages'

export default ({ error, prefix }) => {
  const errKey = `error_${prefix}_${error.status}`
  return (
    <Alert color="warning" className="text-center">
      {messages[errKey]
        ? <FormattedMessage {...messages[errKey]} />
        : error.statusText
      }
    </Alert>
  )
}
